"use strict";

exports.__esModule = true;
exports.ChangePartFeatureDialog = void 0;
var _path2 = _interopRequireDefault(require("ramda/src/path"));
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Translator = require("../../Core/Translator");
var _DeviceContext = require("../../Device/DeviceContext");
var _Timeline = require("../../Timeline");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var AddDialog = (0, _styledComponents["default"])(_core.Dialog).withConfig({
  displayName: "ChangePartFeatureDialog__AddDialog",
  componentId: "sc-1st2plx-0"
})([".", "{border-top:1px solid rgba(0,0,0,0.1);padding-top:1rem;}"], _core.Classes.DIALOG_FOOTER);
var DialogBodySection = _styledComponents["default"].div.withConfig({
  displayName: "ChangePartFeatureDialog__DialogBodySection",
  componentId: "sc-1st2plx-1"
})(["margin:1rem 1rem 0 1rem;"]);
var Row = _styledComponents["default"].div.withConfig({
  displayName: "ChangePartFeatureDialog__Row",
  componentId: "sc-1st2plx-2"
})(["display:flex;padding:1rem 0;"]);
var ChangePartButton = (0, _styledComponents["default"])(_core.Button).withConfig({
  displayName: "ChangePartFeatureDialog__ChangePartButton",
  componentId: "sc-1st2plx-3"
})(["display:flex;margin:0 0 0 1rem;"]);
var PartInstance = _styledComponents["default"].div.withConfig({
  displayName: "ChangePartFeatureDialog__PartInstance",
  componentId: "sc-1st2plx-4"
})(["margin-bottom:1rem;font-weight:bold;"]);
var ChangePartFeatureDialog = exports.ChangePartFeatureDialog = function ChangePartFeatureDialog(props) {
  var label = props.label,
    timelineName = props.timelineName,
    isOpen = props.isOpen,
    handleSubmit = props.handleSubmit,
    toggleDialog = props.toggleDialog;
  var _useState = (0, _react.useState)(""),
    value = _useState[0],
    setValue = _useState[1];
  var _useState2 = (0, _react.useState)(false),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var device = _react["default"].useContext(_DeviceContext.DeviceContext);
  var _React$useContext = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext.translate;
  var timelineDefinition = (0, _Timeline.getTimelineDefinition)(timelineName);
  var timelineResponseKey;
  if (timelineDefinition && timelineDefinition.subscriptionProps && timelineDefinition.subscriptionProps.responseKey) {
    timelineResponseKey = timelineDefinition.subscriptionProps.responseKey;
  } else {
    timelineResponseKey = "";
  }
  var onChangeValue = function onChangeValue(e) {
    setValue(e.target.value);
  };
  var onSubmitStart = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            setLoading(true);
            _context.n = 1;
            return handleSubmit(device, value.trim());
          case 1:
            setTimeout(function () {
              setLoading(false);
              toggleDialog();
            }, 2000);
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function onSubmitStart() {
      return _ref.apply(this, arguments);
    };
  }();
  var onSubmitStop = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            setLoading(true);
            _context2.n = 1;
            return handleSubmit(device, null);
          case 1:
            setTimeout(function () {
              setLoading(false);
              toggleDialog();
            }, 2000);
          case 2:
            return _context2.a(2);
        }
      }, _callee2);
    }));
    return function onSubmitStop() {
      return _ref2.apply(this, arguments);
    };
  }();
  var onClose = function onClose() {
    toggleDialog();
  };
  return /*#__PURE__*/_react["default"].createElement(_Timeline.TimelineSubscription, {
    defaultValue: null,
    timelineName: timelineName,
    query: {
      device: device ? device.uuid : undefined
    },
    isCurrent: true,
    onData: function onData(packet) {
      if (packet && (0, _path2["default"])(timelineResponseKey, packet)) {
        setValue((0, _path2["default"])(timelineResponseKey, packet));
      }
    }
  }, function (packet) {
    var timelineValue = packet && (0, _path2["default"])(timelineResponseKey, packet) || "";
    return /*#__PURE__*/_react["default"].createElement(AddDialog, {
      icon: _icons.IconNames.COG,
      isOpen: isOpen,
      onClose: onClose,
      title: label
    }, /*#__PURE__*/_react["default"].createElement("div", {
      "data-testid": "change-part-feature-dialog"
    }, /*#__PURE__*/_react["default"].createElement(DialogBodySection, null, /*#__PURE__*/_react["default"].createElement(PartInstance, null, translate("ChangePartDialog.current", "Current: {value}", {
      value: timelineValue || "-"
    })), /*#__PURE__*/_react["default"].createElement(Row, null, /*#__PURE__*/_react["default"].createElement(_core.InputGroup, {
      "data-testid": "part-input",
      large: true,
      onChange: onChangeValue,
      value: value,
      placeholder: label
    }), /*#__PURE__*/_react["default"].createElement(ChangePartButton, {
      large: true,
      intent: _core.Intent.PRIMARY,
      loading: loading,
      onClick: onSubmitStart,
      disabled: !value.trim() || value === timelineValue,
      "data-testid": "part-start",
      text: translate("ChangePartDialog.start.Button", "Start")
    }), /*#__PURE__*/_react["default"].createElement(ChangePartButton, {
      large: true,
      intent: _core.Intent.PRIMARY,
      loading: loading,
      onClick: onSubmitStop,
      disabled: value === "" || value !== timelineValue,
      "data-testid": "part-stop",
      text: translate("ChangePartDialog.stop.button", "Stop")
    })))));
  });
};